import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=abca27ae&scoped=true"
import script from "./Showcase.vue?vue&type=script&lang=js"
export * from "./Showcase.vue?vue&type=script&lang=js"
import style0 from "./Showcase.vue?vue&type=style&index=0&id=abca27ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abca27ae",
  null
  
)

export default component.exports